import { v4 as uuidv4 } from 'uuid';

export function GiftDescription() {
	return {
		componentName: 'GiftDescription',
		componentId: uuidv4(),
		draggableType: 'Container',
		droppableType: 'NONE',
		props: {},
		childrenComponents: [],
	};
}
